import { optionsToStrategy } from '@/common/utils/optionsToStrategy'
import { RequiredFieldName } from '@/features/equipmentModels/types/equipmentCategories'

export const requiredFieldOptions = [
  { label: 'Placa', value: RequiredFieldName.LicensePlate },
  { label: 'Chassi', value: RequiredFieldName.ChassisNumber },
  { label: 'Renavam', value: RequiredFieldName.Renavam },
  { label: 'Número de série', value: RequiredFieldName.SerialNumber },
  { label: 'Nome', value: RequiredFieldName.OfficialName },
  { label: 'Capacidade do tanque', value: RequiredFieldName.TankCapacity },
]

export const requiredFieldStrategy = optionsToStrategy(requiredFieldOptions)
